export default __webpack_public_path__ + "static/media/Humidity_white.cbb4a1ac.png";